module.exports = __webpack_public_path__ + "static/img/006_2.d5aa03a8.png";